import { css as e, styled as s } from "styled-components";
import { g as c } from "./style-8UHgYe1v.js";
const f = {
  sm: "2px",
  md: "4px",
  round: "50%"
}, i = {
  spacer0: 0,
  spacer1: 4,
  spacer2: 8,
  spacer3: 12,
  spacer4: 16,
  spacer5: 24,
  spacer6: 32,
  spacer7: 40,
  spacer8: 48,
  spacer9: 56,
  spacer10: 64,
  spacer11: 80,
  spacer12: 128
}, n = Object.fromEntries(
  Object.entries(i).map(([a, t]) => [a, `${t}px`])
), v = {
  below: -1,
  base: 1,
  above: 2,
  dropdown: "calc(var(--z-index-base) + 10)",
  sticky: "calc(var(--z-index-base) + 20)",
  fixed: "calc(var(--z-index-base) + 30)",
  modal: "calc(var(--z-index-base) + 40)",
  popover: "calc(var(--z-index-base) + 50)",
  tooltip: "calc(var(--z-index-base) + 60)",
  insane: 99999,
  // using this value because the christie's navbar uses 9001 zIndex
  drawerOverlay: 9002
}, r = {
  $display: (a) => e`
    display: ${a};
  `,
  $flexDirection: (a) => e`
    flex-direction: ${a};
  `,
  $flexWrap: (a) => e`
    flex-wrap: ${a};
  `,
  $justifyContent: (a) => e`
    justify-content: ${a};
  `,
  $alignItems: (a) => e`
    align-items: ${a};
  `,
  $alignContent: (a) => e`
    align-content: ${a};
  `,
  $gap: (a) => e`
    gap: ${a};
  `,
  $rowGap: (a) => e`
    row-gap: ${a};
  `,
  $columnGap: (a) => e`
    column-gap: ${a};
  `
}, o = e`
  display: flex;
  ${c(r)}
`, y = s.div`
  ${o}
`, l = {
  $order: (a) => e`
    order: ${a};
  `,
  $flexGrow: (a) => e`
    flex-grow: ${a};
  `,
  $flexShrink: (a) => e`
    flex-shrink: ${a};
  `,
  $flexBasis: (a) => e`
    flex-basis: ${a};
  `,
  $alignSelf: (a) => e`
    align-self: ${a};
  `
}, $ = e`
  ${c(l)}
`, w = s.div`
  ${$}
`, p = {
  $p: (a) => e`
    padding: ${n[a]};
  `,
  $px: (a) => e`
    padding-inline: ${n[a]};
  `,
  $py: (a) => e`
    padding-block: ${n[a]};
  `,
  $pt: (a) => e`
    padding-top: ${n[a]};
  `,
  $pr: (a) => e`
    padding-right: ${n[a]};
  `,
  $pb: (a) => e`
    padding-bottom: ${n[a]};
  `,
  $pl: (a) => e`
    padding-left: ${n[a]};
  `
}, d = e`
  ${c(p)}
`, z = s.div`
  ${d}
`, m = {
  $m: (a) => e`
    margin: ${n[a]};
  `,
  $mx: (a) => e`
    margin-inline: ${n[a]};
  `,
  $my: (a) => e`
    margin-block: ${n[a]};
  `,
  $mt: (a) => e`
    margin-top: ${n[a]};
  `,
  $mr: (a) => e`
    margin-right: ${n[a]};
  `,
  $mb: (a) => e`
    margin-bottom: ${n[a]};
  `,
  $ml: (a) => e`
    margin-left: ${n[a]};
  `
}, b = e`
  ${c(m)}
`, u = s.div`
  ${b}
`, g = (a) => e`
  ${({ theme: { theme: t } }) => a[t]}
`, k = e`
  ${g({
  light: e`
      --c-dominant-base: 0, 0%, 13%;
      --c-accent-base: 0, 0%, 100%;
    `,
  grey: e`
      --c-dominant-base: 0, 0%, 13%;
      --c-accent-base: 0, 0%, 100%;
    `,
  dark: e`
      --c-dominant-base: 0, 0%, 100%;
      --c-accent-base: 0, 0%, 13%;
    `
})}
  --c-dominant: hsl(var(--c-dominant-base));
  --c-dominant-alpha-10: hsla(var(--c-dominant-base), 0.1);
  --c-dominant-alpha-40: hsla(var(--c-dominant-base), 0.4);
  --c-dominant-alpha-60: hsla(var(--c-dominant-base), 0.6);
  --c-dominant-alpha-80: hsla(var(--c-dominant-base), 0.8);
  --c-accent: hsl(var(--c-accent-base));
  --c-accent-alpha-10: hsla(var(--c-accent-base), 0.1);
  --c-accent-alpha-40: hsla(var(--c-accent-base), 0.4);
  --c-accent-alpha-60: hsla(var(--c-accent-base), 0.6);
  --c-accent-alpha-80: hsla(var(--c-accent-base), 0.8);
`;
export {
  y as F,
  u as M,
  z as P,
  $ as a,
  w as b,
  k as c,
  f as d,
  n as e,
  o as f,
  b as m,
  d as p,
  i as s,
  g as t,
  v as z
};
